import { CModal } from "@coreui/react";
import React from "react";
import PropTypes from 'prop-types';

const SupportTicketPopup = ({ show, onClose, children }) => {
    return (
        <>
            <div className="support-ticket-popup">
                <CModal visible={show} onClose={onClose} portal={false} backdrop='static' >
                    {children}
                </CModal>
            </div>
        </>
    );
};


SupportTicketPopup.propTypes = {
     onClose: PropTypes.func,
     children: PropTypes.node,
     show: PropTypes.any,
};

export default SupportTicketPopup;
